import { Grid } from '@material-ui/core';
import useScrollButtonState from '@ncr-retail/hooks/build/useScrollButtonState/useScrollButtonState';
import React from 'react';
import { useSelector } from 'react-redux';
import { SizeType } from 'src/common/enumerations/cashier-preference-level';
import { IElectronicJournalRecord } from 'src/common/interfaces/states/IElectronicJournalRecord';
import { AppState } from 'src/common/redux/configure-store';
import { styles } from './action-window-styles';
import { BaseContainer } from './bottom-container/base-container';
import { Summary } from './bottom-container/summary';
import { EJRecordTypes } from '../../common/enumerations/ej-record-types';
import { convertCurrency } from 'src/common/helpers/currency-helper';

const ActionWindowPromotionLine: React.FC<Props> = (props: Props): JSX.Element => {
  const { selectedItem } = props;
  const { items } = useSelector((state: AppState) => state.itemList);

  const classes = styles({});
  const [{ currentPage, lastPage, onPageChanged }, scrollRef] = useScrollButtonState();
  const buttonZoomLevel = useSelector(
    (state: AppState): SizeType => state.cashierPreferences?.buttonZoomLevel || 0,
  );

  let promotionLineHeightVar = '48vh';
  if (buttonZoomLevel === 1) {
    promotionLineHeightVar = '48vh';
  } else if (buttonZoomLevel === 2) {
    promotionLineHeightVar = '46vh';
  }
  return (
    <>
      <Grid
        item
        data-testid='action-window-coupon-id-line'
        xs={props.isKeypadVisible ? 8 : 9}
        className={`${classes.item} ${classes.actionWindowText} ${classes.idLine} ${
          selectedItem.Type === EJRecordTypes.Promotion ? classes.idLineMarginSmall : ''
        } ${props.isKeypadVisible ? classes.smallText : ''}`}
      >
        {selectedItem.CouponId}
      </Grid>

      <Grid
        className={`fullWidth ${classes.eligibilityContainer}`}
        data-testid='action-window-eligibility-container'
      >
        <div
          ref={scrollRef}
          className={`verticalScroll fullWidth `}
          style={{ maxHeight: promotionLineHeightVar }}
        >
          <Grid container>
            {selectedItem.EligibilityInfo.map((e, i) => {
              const item = items?.find(item => item.lineId === Number(e.SequenceNumber));
              const itemPrice = item?.amount;
              return (
                <Grid
                  container
                  justifyContent='space-between'
                  key={i}
                  className={classes.eligibility}
                  data-testid='action-window-eligibility'
                >
                  <Grid item className={classes.promotionDescriptionItem}>
                    <span data-testid='action-window-quantity' className={classes.quantityLabel}>
                      {e.Quantity}
                    </span>
                    <span data-testid='action-window-description' className={classes.price}>
                      {e.Description}
                    </span>
                  </Grid>
                  <Grid item className={classes.promotionPriceItem}>
                    <span className={classes.price} data-testid='action-window-promotion-net-price'>
                      {convertCurrency(itemPrice || 0)}
                    </span>
                  </Grid>
                </Grid>
              );
            })}
          </Grid>
        </div>
      </Grid>
      <Grid className={`fullWidth ${classes.pushToBottom}`}>
        <BaseContainer
          isKeypadVisible={props.isKeypadVisible}
          toggleKeypad={props.toggleKeypad}
          currentPage={currentPage}
          totalPages={lastPage}
          updateCurrentPageHandler={onPageChanged}
        >
          {selectedItem.Savings && (
            <Summary
              heading='Savings'
              value={selectedItem.Savings ?? ''}
              marginNeeded={lastPage < 2}
            />
          )}
        </BaseContainer>
      </Grid>
    </>
  );
};

interface Props {
  isKeypadVisible: boolean | undefined;
  toggleKeypad: () => void;
  selectedItem: IElectronicJournalRecord;
}

export default ActionWindowPromotionLine;
